<template>
  <div>
    <div class="div-input">
      <div :class="['input-custom', { error: isValidate }]">
        <label class="font-weight-bold">
          {{ textFloat }}
          <span v-if="isRequired" class="text-danger">*</span>
        </label>
        <div class="d-flex">
          <div class="w-100 d-flex justify-content-center align-items-center">
            <div class="w-100 display-only">
              <input
                :class="['custom-input']"
                :type="type"
                :placeholder="placeholder"
                :name="name"
                :required="required"
                :value="fileNameDisplay"
                :size="size"
                disabled
              />
              <font-awesome-icon
                icon="times-circle"
                class="text-secondary delete-icon pointer"
                v-if="fileName"
                @click="deleteImage"
              />
            </div>
            <label class="mb-0 btn-main" :size="size">
              <input
                type="file"
                v-on:change="handleFileChange"
                :required="required"
                :name="name"
                ref="input"
                @click="clearValue"
              />
              <font-awesome-icon
                icon="file-upload"
                color="white"
                class="bg-icon mr-2"
                :size="size"
              />{{ $t("chooseFile") }}
            </label>
          </div>

          <b-button
            v-if="isDownload"
            type="button"
            class="btn-download"
            :disabled="fileName == '' || !fileName"
            variant="link"
            @click.prevent="downloadItem(fileName)"
          >
            <font-awesome-icon
              icon="file-download"
              color="white"
              class="bg-icon"
              :size="size"
          /></b-button>
        </div>
      </div>
      <p class="detail-format">{{ text }}</p>
      <div v-if="v && v.$error">
        <span class="text-error f-14" v-if="v.required == false">{{
          $t("pleaseEnterInfo")
        }}</span>
      </div>
      <ModalLoading ref="modalLoading" :hasClose="false" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ModalLoading from "@/components/modal/alert/ModalLoading";
export default {
  components: {
    ModalLoading,
  },
  props: {
    textFloat: {
      required: true,
      type: String,
    },
    text: {
      required: true,
      type: String,
    },
    format: {
      required: true,
      type: String,
    },
    fileName: {
      required: false,
      type: String,
    },
    required: {
      required: false,
      type: Boolean,
    },
    name: {
      required: false,
      type: String,
    },
    isRequired: {
      required: false,
      type: Boolean,
    },
    isValidate: {
      required: false,
      type: Boolean,
    },
    placeholder: {
      required: true,
      type: String,
    },
    size: {
      required: false,
      type: String,
    },
    downloadPath: {
      required: false,
      type: String,
    },
    v: {
      required: false,
      type: Object,
    },
    isDownload: {
      required: false,
      type: Boolean,
    },
    itemIndex: {
      required: false,
      type: Number,
    },
  },
  data() {
    return {
      file: "",
      value: "",
      type: {
        all: ["image/jpeg", "image/png", "video/mp4", ""],
        file: ["image/jpeg", "image/png", "application/pdf"],
        pdf: ["application/pdf"],
        png: ["image/png"],
        image: ["image/jpeg", "image/png"],
        video: ["video/mp4"],
        excel: [
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ],
      },
      error: "",
      hasError: false,
      hasImage: false,
      imgModal: null,
      msgModal: null,
      isSuccess: false,
      dataURL: "",
    };
  },
  computed: {
    fileNameDisplay: function () {
      if (this.fileName != null)
        return this.fileName.split("//").pop().split("/")[2] || this.fileName;
      // if (this.fileName) {
      //   if (this.fileName.includes(this.$baseUrl)) {
      //     return this.fileName.split("\\").pop().split("/")[4];
      //   } else {
      //     return this.fileName;
      //   }
      // } else {
      //   return this.fileName;
      // }
    },
  },
  methods: {
    clearValue(e) {
      e.target.value = "";
    },
    handleFileChange(e) {
      this.hasError = false;
      this.error = "";
      var _validFileExtensions = this.type.file;
      if (this.format == "image") {
        _validFileExtensions = this.type.image;
      } else if (this.format == "video") {
        _validFileExtensions = this.type.video;
      } else if (this.format == "all") {
        _validFileExtensions = this.type.all;
      } else if (this.format == "pdf") {
        _validFileExtensions = this.type.pdf;
      } else if (this.format == "excel") {
        _validFileExtensions = this.type.excel;
      }
      this.value = e.target.files[0];
      // 53687091200 (50 GB)
      if (e.target.files.length) {
        if (_validFileExtensions.indexOf(this.value.type) < 0) {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: "ระบบไม่รองรับไฟล์สกุลนี้",
          });
          return;
        } else if (
          this.value.size > 53687091200 &&
          (this.format == "image" || this.format == "pdf")
        ) {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: "ไฟล์นี้มีขนาดใหญ่เกินไป",
          });
          return;
        } else if (
          this.value.size > 53687091200 &&
          (this.format == "video" || this.format == "all")
        ) {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: "ไฟล์นี้มีขนาดใหญ่เกินไป",
          });
          return;
        } else if (this.value.size > 53687091200 && this.format == "excel") {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: "ไฟล์นี้มีขนาดใหญ่เกินไป",
          });
          return;
        } else {
          this.$emit("onFileChange", this.value, this.itemIndex);
        }
      } else {
        this.value = "";
        this.$refs.input.value = "";
        this.hasError = true;
      }
    },
    downloadImage: async function (path) {
      this.$nextTick(() => {
        var img = new Image();
        img.src = path;
        img.crossOrigin = "Anonymous";

        img.onload = () => {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          this.dataURL = canvas.toDataURL();

          var fileLink = document.createElement("a");
          fileLink.href = this.dataURL;
          fileLink.setAttribute(
            "download",
            `${this.fileName.split("/").pop()}`
          );
          document.body.appendChild(fileLink);
          fileLink.click();
          this.$refs.modalLoading.hide();
        };
      });
    },
    downloadItem: async function (path) {
      this.$refs.modalLoading.show();
      if (path.split(".").pop() == "jpg" || path.split(".").pop() == "png") {
        await this.downloadImage(path);
      } else {
        let pathFile = path;
        axios({
          url: pathFile,
          method: "GET",
          headers: null,
          responseType: "blob",
        }).then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            `download.${response.data.type.split("/").pop(-1)}`
          );
          document.body.appendChild(fileLink);
          fileLink.click();
        });
      }
    },
    deleteImage() {
      this.$emit("delete", this.itemIndex);
      this.hasImage = false;
    },
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.detail-format {
  color: #9b9b9b;
  font-size: 12px;

  margin-top: 3px;
  margin-bottom: 0px;
  /* height: 35px; */
}
.bg-icon.fa-lg {
  margin: 8px 0px;
}
.div-input {
  margin-bottom: 15px;
  position: relative;
  white-space: nowrap;
}
.input-custom {
  padding: 0px;
}
.input-custom > label {
  color: #242424;
  font-size: 17px;
  margin-bottom: 2px;
}
input.custom-input {
  color: #242424;
  background-color: white;
  border: 1px solid #bcbcbc;
  border-radius: 0px;
  padding: 7px 10px;
}
label[size="lg"].btn-main,
input[size="lg"].custom-input {
  height: 45px;
}
.input-custom.error .custom-input {
  border-color: red !important;
}
::-webkit-input-placeholder {
  /* Edge */
  color: rgba(36, 36, 36, 0.4);
}
:-ms-input-placeholder {
  /* Internet Explorer */
  color: rgba(36, 36, 36, 0.4);
}
::placeholder {
  color: rgba(36, 36, 36, 0.4);
}
.custom-input {
  display: block;
  border: none;
  width: 100%;
}
.text-desc {
  color: #242424;
  font-size: 15px;
}
.display-only {
  position: relative;
  z-index: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.btn-main {
  min-width: 125px;
  text-align: center;
  height: 38px;
  vertical-align: middle;
  cursor: pointer;
  background: #242424;
  color: white;
  padding: 7px 10px;
}
.btn-download-file {
  padding: 0;
  text-decoration: underline;
}
.delete-icon {
  position: absolute;
  right: 10px;
  top: 10px;
}
.btn-download {
  width: 50px;
  text-align: center;
  height: 37px;
  vertical-align: middle;
  cursor: pointer;
  background: #242424;
  color: white;
  padding: 7px 10px;
  margin-left: 5px;
  margin-top: 1px;
  border-radius: 0;
}
.text-error {
  color: #ff0000;
}

@media (max-width: 767.98px) {
  .input-custom > label {
    font-size: 15px;
  }
  .detail-format {
    font-size: 11px;
  }
}
</style>
